/**
 * <LabeledIconButton> — a pill button with a required icon + text label (Buttons family, L0.1).
 *
 * Thin typed wrapper over `<Button>` that makes `iconName` mandatory. All chrome (variant /
 * color / size / loading) lives in `<Button>` — do not re-implement the shell here.
 */
import React from "react"

import { Button, type ButtonProps } from "../Button"
import { type IconName } from "../../icons/Icon"

export interface LabeledIconButtonProps extends Omit<ButtonProps, "iconName"> {
    /** FontAwesome5 glyph name — mandatory (this is the icon+label button). */
    iconName: IconName
}

export function LabeledIconButton(props: LabeledIconButtonProps) {
    return <Button {...props} />
}
